import { Link } from 'react-router';

import { Box } from '@mui/material';

import { FooterList } from 'components/footer/FooterList';
import { Logo } from 'components/images';

/**
 * Rodapé padrão do sistema, geralmente fixo no final da página
 * Contém logo do cliente + menu com links do rodapé
 */
export function Footer() {
    return (
        <Box component="footer" sx={{ mt: 'auto', backgroundColor: 'secondary.main' }}>
            <Box sx={{ display: 'flex', maxWidth: 'xl', mx: 'auto', px: 2, py: 4, color: 'common.white' }}>
                <FooterList />

                <Box component={Link} to="/" title="Página inicial" sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <Logo />
                </Box>
            </Box>
        </Box>
    );
}
